import {Modal} from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import React, {useEffect, useState} from 'react';
import {cloneDeep} from 'lodash';
import {DEFAULT_PAGE_SIZE, LOCAL_STORAGE_USER_LOGIN_INFO, ORDER_BY, ResponseCode} from "@app/constants/Common";
import {arrayToString} from "@app/utils/CommonUtils";
import {alertMessage, showMessage} from "@app/constants/Messages";
import {
    requestDeleteExcludeEmployerIds,
    requestGetExcludeEmployerIds,
    requestSaveExcludeEmployerIds
} from "@pages/dvtjcuv/service/DVTJCUVSearchCddJobService";
import {requestGetEmployerList} from "@app/services/EmployerService";
import EmployerList from "@pages/employer/list/EmployerList";
import EmployerListTable, {EmployerListTableMode} from "@pages/employer/list/EmployerListTable";
import Select from "react-select";


const DVTJCUVSearchJobExcludeEmployerModal = (props) => {
    const [searchConditions, setSearchConditions] = useState(cloneDeep({}));
    const [userLoginInfo, setUserLoginInfo] = useState({});
    const [employers, setEmployers] = useState([]);
    const [allEmployerIds, setAllEmployerIds] = useState([]);
    const [totalCount, setTotalCount] = useState(0);
    const [inputIds, setInputIds] = useState('');
    const [inputEmployerIds, setInputEmployerIds] = useState([]);
    const [notes, setNotes] = useState('');
    const [isProcessing, setProcessing] = useState(false);
    const [employerOptions, setEmployerOptions] = useState([]);
    const [selectEmployers, setSelectEmployers] = useState([]);


    const {cddId, isShow, onClose} = props

    const fetchEmployees = async () => {
        const res = await requestGetEmployerList({})
        const allEmployees = res.content.employers;
        const empOptionList = []
        allEmployees.forEach((item, index) => {
            empOptionList.push({value: item.id, label: item.name})
        });
        // empOptionList.push({value: 'create_new_emp', label: ' + Tạo mới'})
        setEmployerOptions(empOptionList);
    }

    const searchEmployerList = async (condition) => {
        let params = {search_conditions: condition}
        // params.search_conditions.employer_ids =
        const res = await requestGetEmployerList(params)

        const items = res.content.employers.map((item, index) => {
            item.no = (res.content.page - 1) * DEFAULT_PAGE_SIZE + index + 1
            return item
        });
        setEmployers(items);
        setAllEmployerIds(res.content.all_employer_ids);
        setTotalCount(res.content.totalCount)
        // setCurrentPage(res.content.page)
        // setNumberPages(Math.floor(Number(res.content.totalCount) / DEFAULT_PAGE_SIZE) + 1);
    }

    const fetchExcludeEmployers = async () => {
        const params = {
            order_by: ORDER_BY.DESC_UPDATE_DATE,
            search_conditions: searchConditions
        }
        params.cdd_id = cddId

        const res = await requestGetExcludeEmployerIds(params);
        if (res.sts_code === ResponseCode.SUCCESS) {
            const empIds = res.content;
            if (empIds.length > 0) {
                searchEmployerList({employer_ids: empIds})
            } else {
                setEmployers([])
            }
        } else {
            alertMessage(res.sts_code)
        }
    }

    useEffect(() => {
        if (cddId) {
            fetchExcludeEmployers()
        }
    }, [cddId]);

    useEffect(() => {
        if (!userLoginInfo.id && localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)) {
            setUserLoginInfo(JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)))
        }
        fetchEmployees();
    },[])

    const onAddExcludeEmployerIds = () => {
        const request = {cdd_id: cddId, notes: notes}
        request.employer_ids = selectEmployers.map(item => {
            return item.value
        })

        setInputEmployerIds(request.employer_ids)
        requestSaveExcludeEmployerIds(request).then(res => {
            if (res.sts_code === ResponseCode.SUCCESS) {
                const notExistsRecIds = res.content.not_exist_emp_ids
                const successRecIds = res.content.success_emp_ids
                showMessage(
                    `Số Employer Ids lưu thành công: ${successRecIds.length} ${notExistsRecIds.length ? '\nEmployerIds lưu thất bại: ' + arrayToString(notExistsRecIds) : ''}`)
                fetchExcludeEmployers()
            } else {
                showMessage(res.message, true, true)
            }
        })
    }

    const onDeleteExcludeEmployerIds = (ids) => {
        if (!ids || ids.length === 0) {
            showMessage('Vui lòng chọn Employer id')
            return;
        }

        if (window.confirm("Bạn chắc chắn muốn xóa Employers này?") === true) {
            const request = {cdd_id: cddId, notes: notes}
            request.employer_ids = ids;
            requestDeleteExcludeEmployerIds(request).then(res => {
                if (res.sts_code === ResponseCode.SUCCESS) {
                    fetchExcludeEmployers()
                } else {
                    showMessage(res.message, true, true)
                }
            })
        }
    }

    const onChangeEmployerInput = (event) => {
        console.log('onChangeEmployerInput');
        setSelectEmployers([...event]);
    };

    return (
        <>
            <Modal show={isShow}
                   fullscreen style={{zIndex: 3002}}
                   onHide={onClose}
                   animation={false}>
                <Modal.Header>
                    <Modal.Title>Loại trừ Employers</Modal.Title>
                    <Button variant='secondary' onClick={onClose}>
                        Close
                    </Button>
                </Modal.Header>
                <Modal.Body style={{overflowY: 'auto'}}>
                    <div className={'card card-default'}>
                        <div className='card-header'>
                            <h3 className='card-title text-bold'>Danh sách Employers</h3>
                            <div className={'card-tools'} style={{width:'50%'}}>
                                <label>Chọn Employers:</label>
                                <div className={'row'}>
                                    {/*<input*/}
                                    {/*    className={'form-control mr-1 col-sm-5'}*/}
                                    {/*    type='text'*/}
                                    {/*    value={inputIds}*/}
                                    {/*    onChange={(event) => {*/}
                                    {/*        const values = event.target.value*/}
                                    {/*        if (!values || /^[0-9\s]*$/.test(values)) {*/}
                                    {/*            setInputIds(values);*/}
                                    {/*        }*/}
                                    {/*    }}*/}
                                    {/*    placeholder={'Nhập Employer Id cách nhau bởi dấu cách. Ví dụ: 1 2 3'}*/}
                                    {/*/>*/}
                                    <Select options={employerOptions}
                                            placeholder={"Chọn employer"}
                                            value={selectEmployers}
                                            name={"employer"}
                                            isMulti
                                            onChange={values => {
                                                onChangeEmployerInput(values);
                                            }}
                                    />
                                    <input className={'form-control mr-1 col-sm-5'}
                                           type='text'
                                           value={notes}
                                           onChange={(event) => setNotes(event.target.value)}
                                           placeholder={'Notes'}
                                    />
                                    <button type='button'
                                            className='btn btn-info btn-sm float-right'
                                            disabled={selectEmployers.length === 0 || isProcessing}
                                            onClick={onAddExcludeEmployerIds}>
                                        { isProcessing ? 'Processing...' : 'Add Employers' }
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className='card-body'>
                            {/*<CandidateListTable*/}
                            {/*    showBtnSelect*/}
                            {/*    candidates={employers}*/}
                            {/*    allCandidateIds={allEmployerIds}*/}
                            {/*    mode={CandidateListMode.DVTJCUV_SEARCH_CDD_JOB_EXCLUDE_EMPLOYERS}*/}
                            {/*    totalCount={totalCount}*/}
                            {/*    onDelete={onDeleteExcludeEmployerIds}*/}
                            {/*/>*/}
                            <EmployerListTable employers={employers}
                                               showBtnSelect
                                               allEmployerIds={allEmployerIds}
                                               totalCount={totalCount}
                                               hideSearchForm
                                               onDelete={onDeleteExcludeEmployerIds}
                                               mode={EmployerListTableMode.RUN_DVTJCUV_SEARCH_CDD_EXCLUDE_EMPLOYERS}
                                               onSearch={(condition) => searchEmployerList(condition)}/>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default DVTJCUVSearchJobExcludeEmployerModal;
